// IMPORT REACT
import React from 'react';

// IMPORT IMAGES
import { ReactComponent as IconApple } from '../../images/icon-apple.svg';
import { ReactComponent as IconCaret } from '../../images/icon-caret.svg';
import { ReactComponent as IconComments } from '../../images/icon-comments.svg';
import { ReactComponent as IconFile } from '../../images/icon-file.svg';
import { ReactComponent as IconFolder } from '../../images/icon-folder.svg';
import { ReactComponent as IconFolderOpen } from '../../images/icon-folder-open.svg';
import { ReactComponent as IconGooglePlay } from '../../images/icon-google-play.svg';
import { ReactComponent as IconGrid } from '../../images/icon-grid.svg';
import { ReactComponent as IconImage } from '../../images/icon-image.svg';
import { ReactComponent as IconList } from '../../images/icon-list.svg';
import { ReactComponent as IconLock } from '../../images/icon-lock.svg';
import { ReactComponent as IconTimes } from '../../images/icon-times.svg';
import { ReactComponent as IconUserPlus } from '../../images/icon-user-plus.svg';
import { ReactComponent as IconUtensils } from '../../images/icon-utensils.svg';
import { ReactComponent as IconVideoPlay } from '../../images/icon-video-play.svg';
import { ReactComponent as IconWarning } from '../../images/icon-warning.svg';

// IMPORT STYLES
import { SC_Icon, SC_IconRatio, SC_CanvasRatio } from './styles';

const identifyComponent = (icon) => {
	const components = {
	  'apple': IconApple,
	  'caret': IconCaret,
	  'comments': IconComments,
	  'file': IconFile,
	  'folder': IconFolder,
	  'folder-open': IconFolderOpen,
	  'google-play': IconGooglePlay,
	  'grid': IconGrid,
	  'image': IconImage,
	  'list': IconList,
	  'lock': IconLock,
	  'times': IconTimes,
	  'user-plus': IconUserPlus,
	  'utensils': IconUtensils,
	  'video-play': IconVideoPlay,
	  'warning': IconWarning
	}
	return components[icon] ? components[icon] : components['warning'];
} 

class YAIcon extends React.Component {

	state = {
		iconWidth: null,
		iconHeight: null
	};

	refCallback = element => {
		if (element) {
			const iconViewBox = element.getAttribute('viewBox').split(' ');
			this.setState({ 
				iconWidth: iconViewBox[2],
				iconHeight: iconViewBox[3] 
			});
		}
	};

	render(){
		let Template = identifyComponent(this.props.icon);
		let iconWidth = this.state.iconWidth;
		let iconHeight = this.state.iconHeight;
    return (
    	<SC_Icon {...this.props}>
				<SC_IconRatio>
					<SC_CanvasRatio width={iconWidth} height={iconHeight} />
    			<Template aria-labelledby={'icon-'+this.props.icon} ref={this.refCallback} />
				</SC_IconRatio>
    	</SC_Icon>
  	)
	}
}
export default YAIcon;